import React, { useEffect, useState } from "react";
import HeaderRelatorio from "../HeaderRelatorio";
import InputDateForm from "../../../components/Input/InputDateForm";
import MultipleSelectCheckbox from "../../../components/Select/MultipleSelectCheckbox";
import { observer } from "mobx-react-lite";
import { CircularProgress, Grid, withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import moment from "moment";
import classNames from "classnames";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import Table from "../../../components/Table/Table";
import { Button } from "../../../components/ui/Buttons";
import ArrowDownloadIcon from "../../../components/Icon/ArrowDownload";
import PrintIcon from "../../../components/Icon/Print";
import ImpressaoHtml from "../../../components/Impressao/ImpressaoHtml";
import Notification from "../../../components/Notification";
import { columns, filtrosDefault, situacoesOptionsDefault } from "./Constants";
import AtendimentosPorProfissional from "./AtendimentosPorProfissional";
import { base64Convert } from "../../../utils/base64ToCsv";
import {
  relatorioAtendimentoPorProfissionalCsv,
  relatorioAtendimentosPorProfissional,
  relatorioAtendimentosPorProfissionalPdf,
} from "../../../services/RelatorioService";
import { findAllProfissionalSaude } from "../../../services/ProfissionalSaudeService";
import { TextFieldSearch } from "../../../components/TextField";

const pageableDto = {
  pageSize: 30,
  sortDir: "ASC",
  sortField: "nomeProfissional",
};

const RelatorioAtendimentosPorProfissional = observer(
  ({ classes, relatorioStore }) => {
    const [filters, setFilters] = useState(filtrosDefault);
    const [situacoesOptions, setSituacoesOptions] = useState(
      situacoesOptionsDefault
    );
    const [isLoading, setIsLoading] = useState(false);
    const [atendimentos, setAtendimentos] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [last, setLast] = useState(false);
    const [search, setSearch] = useState("");
    const [isPrintMustache, setIsPrintMustache] = useState(false);
    const [relatorio,setRelatorio]=useState([])
    const [notification, setNotification] = useState({
      open: false,
      message: "",
    });

    useEffect(() => {
      loadAtendimentos({ isClearable: true });
    }, []);

    const loadAtendimentos = async (options) => {
      try {
        const { dataInicio, dataFim, situacoes, profissionalSaude } = filters;

        if (!dataInicio || !dataFim) {
          return showAlertMessage({
            open: true,
            message: "Informe a data inicial e final!",
            variant: "error",
          });
        }

        setIsLoading(true);
        const response = await relatorioAtendimentosPorProfissional({
          pageableDto: {
            ...pageableDto,
            pageNumber: options?.isClearable ? 0 : pageNumber,
          },
          dataInicio: moment(dataInicio).format("YYYY-MM-DD"),
          dataFim: moment(dataFim).format("YYYY-MM-DD"),
          situacoes,
          ...(search && { search }),
          ...(profissionalSaude?.id && { profissionalSaudeId: profissionalSaude.id })
        });

        const { content, last } = response;

        setAtendimentos(
          options?.isClearable ? content : [...atendimentos, ...content]
        );
        setPageNumber(options?.isClearable ? 1 : pageNumber + 1);
        setLast(last);
      } catch (error) {
        showAlertMessage({
          open: true,
          variant: "error",
          message: "Erro ao carregar o relatório de agendamentos por usuario",
        });
      } finally {
        setIsLoading(false);
      }
    };

    const handleFilters = (value, field) => {
      setFilters({ ...filters, [field]: value });
    };

    const toggleAllSituacoes = (valueToToggle) => {
      const situacoes = situacoesOptions.map((item) => {
        return {
          ...item,
          checked: valueToToggle,
        };
      });
      let situacoesChecked = situacoes.filter(
        (situacao) => situacao.value !== "TODAS_SITUACOES" && situacao.checked
      );
      let arraySituacoesCheckedValue = situacoesChecked.map(
        (situacao) => situacao.value
      );

      setSituacoesOptions(situacoes);
      setFilters((filter) => ({
        ...filter,
        situacoes: arraySituacoesCheckedValue,
      }));
    };

   const checkAllSituacoesChecked = (checkedSituacoes, isChecked, situacoes) => {
    let todasSituacoesIndex = situacoesOptions.findIndex(
      (element) => element.value === "TODAS_SITUACOES"
    );

    const todasSituacoesObject = situacoes[todasSituacoesIndex];
    if (isChecked && todasSituacoesObject.checked) {
      situacoes[todasSituacoesIndex] = {
        ...todasSituacoesObject,
        checked: false,
      };
    }
    if (checkedSituacoes.length === 7) {
      situacoes[todasSituacoesIndex] = {
        ...todasSituacoesObject,
        checked: true,
      };
    }
  };


      const handleChangeSelectCheckbox = (item) => {
    if (item.value === "TODAS_SITUACOES") {
      return toggleAllSituacoes(!item.checked);
    }

    const situacaoIndex = situacoesOptions.findIndex(
      (element) => element.value === item.value
    );

    let situacoes = [...situacoesOptions];
    situacoes[situacaoIndex] = { ...item, checked: !item.checked };

    let situacoesChecked = situacoes.filter(
      (situacao) => situacao.value !== "TODAS_SITUACOES" && situacao.checked
    );

    const arraySituacoesValue = situacoesChecked.map((situacao) => {
      return situacao.value;
    });
    checkAllSituacoesChecked(situacoesChecked, item.checked, situacoes);
    setFilters((filter) => ({ ...filter, situacoes: arraySituacoesValue }));
    setSituacoesOptions(situacoes);
  };

    const getSituacaoInputPlaceholder = () => {
      let situacoesChecked = situacoesOptions.filter(
        (situacao) => situacao.value !== "TODAS_SITUACOES" && situacao.checked
      );
      if (situacoesChecked.length === 0) {
        return "Selecione";
      }

      if (situacoesChecked.length > 0 && situacoesChecked.length <= 4) {
        return situacoesChecked.length === 1
          ? "1 situação"
          : `${situacoesChecked.length} situações`;
      }

      return "Todas as situações";
    };

    const showAlertMessage = (notification) => {
      setNotification(notification);

      const timeoutId = setTimeout(() => {
        closeAlertMessage();
        clearTimeout(timeoutId);
      }, 3000);
    };

    const closeAlertMessage = () => {
      const notification = {
        open: false,
        message: "",
      };
      setNotification(notification);
    };

    const handleDownloadCSV = async () => {
      const { dataInicio, dataFim, situacoes } = filters;

      if (!dataInicio || !dataFim) {
          return showAlertMessage({
            open: true,
            message: "Informe a data inicial e final!",
            variant: "error",
          });
        }

      const base64 = await relatorioAtendimentoPorProfissionalCsv({
        pageableDTO: {
          ...pageableDto,
          pageNumber: 0,
        },
        dataInicio: moment(dataInicio).format("YYYY-MM-DD"),
        dataFim: moment(dataFim).format("YYYY-MM-DD"),
        situacoes,
        ...(search && { search }),
      });

      if (base64 === "error") return;
      const blob = base64Convert(base64);
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "relatorioAgendamentosUsuario.csv");
      document.body.appendChild(link);
      link.click();
    };

    const handlePrint = async ()  => {
      try {
        const { dataInicio, dataFim,  situacoes, profissionalSaude  } = filters;
        if (!dataInicio || !dataFim) {
          return showAlertMessage({
            open: true,
            message: "Informe a data inicial e final!",
            variant: "error",
          });
        }

        const variables = {
          pageableDto: {
            sortDir: pageableDto.sortDir,
            sortField: pageableDto.sortField
          },
          dataInicio: moment(dataInicio).format("YYYY-MM-DD"),
          dataFim: moment(dataFim).format("YYYY-MM-DD"),
          situacoes,
          ...(search && { search }),
          ...(profissionalSaude?.id && { profissionalSaudeId: profissionalSaude.id })
        }

        const response = await relatorioAtendimentosPorProfissionalPdf(variables);

        setRelatorio(response)
        setIsPrintMustache(true);
      } catch (error) {
        console.error(error)
        showAlertMessage({ open: true, message: "Erro ao imprimir!" });
      }
    };

    const onChangeSearch = (e) => {
      setSearch(e.target.value);
    };

    const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
      try {
        const { mostrarApenasProfissionaisAtivo } =
          relatorioStore.configuracaoUnidade || {};
        const { content, last } = (
          await findAllProfissionalSaude({
            pageNumber: page,
            search,
            possuiAgenda: true,
            ...(mostrarApenasProfissionaisAtivo && {ativo: mostrarApenasProfissionaisAtivo}),
          })
        ).data.data.findAllProfissionalSaude;
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error(error);
      }
    };

    return (
      <div>
        <HeaderRelatorio
          idPrefix="rel-app"
          title="Relatório de atendimentos por profissional"
          hiddenButtons
          hiddenTotal
          hideEndAdornment
          onChange={onChangeSearch}
          search={() => loadAtendimentos({ isClearable: true })}
        />
        <div className={classes.contentFiltros}>
          <div className={classes.filtros}>
            <div className={classes.campoFiltro}>
              <span className={classes.tituloFiltros}> Data início: </span>
              <InputDateForm
                id="rel-app-inp-ini"
                iconposition="end"
                openTo="day"
                views={["year", "month"]}
                value={filters.dataInicio || ""}
                onChange={(e) => handleFilters(e, "dataInicio")}
                classes={{
                  input: classes.inputData,
                }}
              />
            </div>
            <div className={classes.campoFiltro}>
              <span className={classes.tituloFiltros}> Data Fim: </span>
              <InputDateForm
                id="rel-app-inp-fim"
                iconposition="end"
                openTo="day"
                views={["year", "month"]}
                value={filters.dataFim || ""}
                onChange={(e) => handleFilters(e, "dataFim")}
                classes={{
                  input: classes.inputData,
                }}
              />
            </div>
            <div className={classes.campoFiltro}>
              <span className={classes.tituloFiltros}> Situação: </span>
              <MultipleSelectCheckbox
                id="rel-app-sel-sit"
                listaOpcoes={situacoesOptions}
                changeCheckbox={handleChangeSelectCheckbox}
                withCustomText
                customText={getSituacaoInputPlaceholder()}
                classes={{
                  select: classNames(classes.inputContainer, classes.select),
                  popper: classes.selectMenu,
                }}
              />
            </div>
            <div className={classes.campoFiltro}>
              <span className={classes.tituloFiltros}> Profissional: </span>
              <TextFieldSearch
                id="rel-app-sel-prf"
                placeholder="Selecione"
                classNotched={classes.notchedOutline}
                loadOptions={loadProfissionaisSaude}
                getOptionLabel={(option) => option?.nome}
                getOptionValue={(option) => option?.id}
                value={filters.profissionalSaude}
                onChange={(e) => handleFilters(e, "profissionalSaude")}
                withPaginate
                debounceTimeout={300}
                additional={{
                  page: 0,
                }}
                menuPosition="fixed"
              />
            </div>
          </div>
          <div className={classes.buttonFilter}>
            <Button
              id="rel-app-btn-fil"
              shape="pill"
              bgColor="#707C97"
              onClick={() => loadAtendimentos({ isClearable: true })}
            >
              Filtrar
            </Button>
          </div>
        </div>
        <div className={classes.tableContainer}>
          {atendimentos.length === 0 && !isLoading && <MensagemListaVazia />}
          {atendimentos?.length > 0 && (
            <Scroll
              loadMore={loadAtendimentos}
              hasMore={!last}
              pageStart={0}
              initialLoad={false}
            >
              <Table
                dados={atendimentos}
                columns={columns}
              />
            </Scroll>
          )}
          {isLoading && (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: "100%", marginTop: 20 }}
            >
              <CircularProgress size={30} />
            </Grid>
          )}
        </div>
        <div className={classes.buttonsDownloadPrint}>
          <Button
            id="rel-app-btn-imp"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handlePrint}
            disabled={atendimentos.length === 0}
          >
            <PrintIcon />
          </Button>
          <Button
            id="rel-app-btn-csv"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handleDownloadCSV}
            disabled={atendimentos.length === 0}
          >
            <ArrowDownloadIcon />
          </Button>
        </div>
        {isPrintMustache && (
          <ImpressaoHtml
            isPrintMustache={isPrintMustache}
            handlePrintMustache={() => setIsPrintMustache(false)}
            htmlStringComponent={
              <AtendimentosPorProfissional
                dadosRelatorio={relatorio || []}
                filters={filters}
              />
            }
          />
        )}

        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.open}
          variant={"error"}
          message={notification.message}
        />
      </div>
    );
  }
);

const styles = {
  contentFiltros: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    padding: "13px 16px 8px 16px",
    boxShadow:
      "10px 10px 25px rgb(112 124 151 / 5%), 15px 15px 35px rgb(112 124 151 / 5%)",
    background: "#fff",
    marginTop: 1,
    gap: "8px",
  },
  filtros: {
    gap: "8px",
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  campoFiltro: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "150px",
  },
  notchedOutline: {
    border: "0",
  },
  tituloFiltros: {
    color: "#868686",
    fontSize: "12px !important",
  },
  inputContainer: {
    display: "flex",
    background: "#F2F2F2",
    color: "#505050",
    borderRadius: "8px",
    border: "none",
    "& > div": {
      "& > p": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
  },
  selectMenu: {
    marginTop: "4px",
    width: "165px",
    zIndex: 1000,
  },
  wrapperCheckbox: {
    display: "flex",
    alignItems: "center",
    flex: 2,
  },
  buttonsDownloadPrint: {
    display: "flex",
    position: "absolute",
    bottom: "80px",
    right: "14px",
    width: "88px",
    justifyContent: "space-between",
  },
  buttonFilter: {
    display: "flex",
    alignItems: "center",
  },
  tableContainer: {
    height: "calc(100vh - 218px)",
  },
};

const stores = ["relatorioStore"];
const RelatorioAtendimentosPorProfissionalWithStyles = withStyles(styles)(
  RelatorioAtendimentosPorProfissional
);
export default inject(...stores)(
  RelatorioAtendimentosPorProfissionalWithStyles
);
